import { ALERT_TYPES } from '../constants';

export const VIEWS = {
	ACTIVITY: 'Activity',
	ADD_CONTACT: 'Add Contact',
	ADD_NOTE: 'Add Note',
	ALERT_DETAILS: 'Alert Details',
	ALERT_LIST: 'Alert List',
	ALERT_SETTINGS: 'Alert Settings',
	CONTACT_DETAILS: 'Contact Details',
	CONTACT_SETTINGS: 'Contact Settings',
	DEACTIVATE_CONTACT: 'Mark Contact Inactive',
	DEACTIVATE_CONTACTS: 'Mark Contacts Inactive',
	DELETE_LOAN: 'Delete Loan',
	DUPLICATE_CONTACT: 'Duplicate Contact',
	DUPLICATE_LOAN: 'Duplicate Loan',
	HOME: 'Home',
	INACTIVE_CONTACT: 'Inactive Contact',
	LOAN_DETAILS: 'Loan Details',
	LOANS_LIST: 'Loans List',
	REACTIVATE_CONTACT: 'Reactivate Contact',
	REACTIVATE_CONTACTS: 'Reactivate Contacts',
	SEND_TO_BLINK: 'Send to Blink+',
	SEND_TO_VENDOR: 'Send to Vendor',
	TRANSFER_CONTACT: 'Transfer Contact',
	UPDATE_CONTACT_TYPE: 'Change Contact Type',
	CONFIRM_FILTER_SELECTION: 'Confirm Filter Selection',
};

export const TABS = [
	{
		name: 'Details',
		view: VIEWS.CONTACT_DETAILS,
		description: 'View personal details of this contact.',
		icon: {
			name: 'user',
			style: 'far',
		},
	},
	{
		name: 'Alerts',
		view: VIEWS.ALERT_LIST,
		description: 'View a list of alerts for this contact.',
		icon: {
			name: 'bell',
			style: 'far',
		},
	},
	{
		name: 'Loans',
		view: VIEWS.LOANS_LIST,
		description: 'View all loans owned by this contact.',
		icon: {
			name: 'home-lg-alt',
			style: 'far',
		},
	},
	{
		name: 'Activity',
		view: VIEWS.ACTIVITY,
		description: 'View all notes and activity for this contact.',
		icon: {
			name: 'list-ul',
			style: 'far',
		},
	},
	{
		name: 'Settings',
		view: VIEWS.CONTACT_SETTINGS,
		description: 'View and edit settings for this contact',
		icon: {
			name: 'cog',
			style: 'far',
		},
	},
];

export const DISPLAY_TYPES = {
	STATUS: 'Status',
	LEAD_LINK: 'LeadLink',
	EMAIL: 'Email',
	PHONE: 'Phone',
	LOAN_LINK: 'LoanLink',
	DATE: 'Date',
	PERCENTAGE: 'Percentage',
	CURRENCY: 'Currency',
};

export const CONTACT_LEVEL_ALERTS = ['Credit', 'UConnect', 'Birthday'];

// TODO: Work with backend devs to move this to the backend after CCv2 release
export const ALERT_DESCRIPTIONS = [
	{
		name: ALERT_TYPES.RATE,
		description: 'Alerts you when a lower rate is available to your borrower.',
	},
	{
		name: ALERT_TYPES.CREDIT,
		description:
			"Alerts you when a borrower's credit score has approved above a target FICO.",
	},
	{
		name: ALERT_TYPES.UNITE,
		description:
			'Alerts you when a borrower has reached a certain amount of equity and gives you the estimated home value and current LTV.',
	},
	{
		name: ALERT_TYPES.UCONNECT,
		description: 'Alerts you when a borrower is shopping for a new mortgage.',
	},
	{
		name: ALERT_TYPES.MI_DROP_ELIGIBLE,
		description:
			"Alerts you when a borrower's LTV drops below 80% and is eligible to drop MI.",
	},
	{
		name: ALERT_TYPES.NEW_LISTING,
		description: "Alerts you when a borrower's property is listed.",
	},
	{
		name: ALERT_TYPES.BIRTHDAY,
		description: 'Alerts you when a borrower is celebrating a birthday.',
	},
	{
		name: ALERT_TYPES.LOAN_ANNIVERSARY,
		description:
			'Alerts you when a borrower is celebrating a loan anniversary.',
	},
	{
		name: ALERT_TYPES.REVIEW_ME,
		description:
			'Alerts you when a new loan closes with a borrower so you can sent them an email to review your services as a mortgage broker.',
	},
];

export const NEW_LOAN = {
	loanId: null,
	amortizationType: {
		amortizationTypeId: 0,
		amortizationTypeDesc: null,
	},
	appraisedValue: '',
	closingDate: null,
	closingLOContactId: null,
	closingLOEntityId: null,
	closingLTV: '',
	HCLTV: '',
	interestRate: '',
	lienPosition: {
		lienPositionId: null,
		lienPositionDesc: null,
	},
	loanAmount: '',
	loanNumber: '',
	occupancyType: {
		occupancyTypeId: 0,
		occupancyTypeDesc: null,
	},
	paidInFullInd: false,
	product: null,
	productId: null,
	propertyType: {
		propertyTypeId: 0,
		propertyTypeDesc: null,
	},
	purpose: {
		purposeId: 0,
		purposeDesc: null,
		purposeType: null,
	},
	subjectPropertyAddress: {
		addressLine1: null,
		addressLine2: null,
		unitNumber: null,
		city: null,
		state: null,
		zipCode: null,
	},
	term: null,
	totalLineAmount: '',
	type: {
		typeId: 0,
		typeDesc: null,
	},
	uwmInd: false,
};
